export const dataListAgencies = [
  {
    alias: 'Lima, Ate',
    data: {
      department: 'Lima',
      province: 'Lima',
      district: 'Ate',
      name: 'Copytip S.R.L',
      address: 'Jr. Los Aymaras 221 - Salamanca - 4342356/ 992436369'
    }
  },
  {
    alias: 'Lima, Callao',
    data: {
      department: 'Lima',
      province: 'Lima',
      district: 'Callao',
      name: 'Power Publicidad EIRL',
      address: 'Av. Bocanegra Mz. G Lote 41 Urb. Los Jazmines 1ra. Etapa - 999223232'
    }
  },
  {
    alias: 'Lima, Chorrillos',
    data: {
      department: 'Lima',
      province: 'Lima',
      district: 'Chorrillos',
      name: 'Aito Service S.A.C.',
      address: 'Av. Alejandro Iglesias 472 - 945677497'
    }
  },
  // {
  //   alias: 'Lima, Chorrillos',
  //   data: {
  //     department: 'Lima',
  //     province: 'Lima',
  //     district: 'Chorrillos',
  //     name: 'Comercial Matellini S.R.L.',
  //     address: 'Av. P. de la Republica 1397 Matellini'
  //   }
  // },
  {
    alias: 'Lima, Breña',
    data: {
      department: 'Lima',
      province: 'Lima',
      district: 'Breña',
      name: 'El Comercio',
      address: 'Jr. Jorge Chavez 346 - Telef: 984257202 / WSP. :926061745'
    }
  },
  // {
  //   alias: 'Lima, Comas',
  //   data: {
  //     department: 'Lima',
  //     province: 'Lima',
  //     district: 'Comas',
  //     name: 'Megapoint Publicidad y Marketing E.I.R.L.',
  //     address: 'Av. Tupac Amaru 5313 Urb. Huaquillay'
  //   }
  // },
  // {
  //   alias: 'Lima, Jesus Maria',
  //   data: {
  //     department: 'Lima',
  //     province: 'Lima',
  //     district: 'Jesus Maria',
  //     name: 'Alcance Publicidad Soc. Comercial de Resp. Ltda',
  //     address: 'Av. Gral Garzon 1420'
  //   }
  // },
  {
    alias: 'Lima, Jesus Maria',
    data: {
      department: 'Lima',
      province: 'Lima',
      district: 'Jesus Maria',
      name: 'T&S SAC Promotores Publicistas',
      address: 'Edificio Las Orquideas 111 - Urb. Residencial San Felipe - 997494500 / 998190973'
    }
  },
  {
    alias: 'Lima, Jesus Maria',
    data: {
      department: 'Lima',
      province: 'Lima',
      district: 'Jesus Maria',
      name: 'Adomar Publicidad S.A.C.',
      address: 'Jr. Huascar 1306 - 1308 (altura entre la 11 y 12 Av. Cuba) - 654-3612 / WSP. 947-301-925'
    }
  },
  {
    alias: 'Lima, La Molina',
    data: {
      department: 'Lima',
      province: 'Lima',
      district: 'La Molina',
      name: 'De la Divina Gracia S.R.L.',
      address: 'Av. La Molina 2830 Int. B-19 C.C. Molicentro - 998 338 359 / 998 338 315 / 368-2289 / 368-0502'
    }
  },
  // {
  //   alias: 'Lima, La Victoria',
  //   data: {
  //     department: 'Lima',
  //     province: 'Lima',
  //     district: 'La Victoria',
  //     name: 'A Y N Publicidad y Servicios E.I.R.L.',
  //     address: 'Jr. Saenz Peña 451'
  //   }
  // },
  {
    alias: 'Lima, La Victoria',
    data: {
      department: 'Lima',
      province: 'Lima',
      district: 'La Victoria',
      name: 'Diseño y Publicidad A&M S.R.L.',
      address: 'Av. Aviación 1155 - 99403-2691'
    }
  },
  {
    alias: 'Lima, La Victoria',
    data: {
      department: 'Lima',
      province: 'Lima',
      district: 'La Victoria',
      name: 'Maria Elizabeth Evanan Mendoza',
      address: 'Av. Nicolas Arriola 898 Int. 3 (Dentro del terminal transportes CROMOTEX) Urb. Santa Catalina - 989733552'
    }
  },
  {
    alias: 'Lima, La Molina',
    data: {
      department: 'Lima',
      province: 'Lima',
      district: 'La Molina',
      name: 'Publimark Rosser E.I.R.L.',
      address: 'Av. Flora Tristan 946 - 2653553 / 992275569 / 991-013939'
    }
  },
  // {
  //   alias: 'Lima, Lima',
  //   data: {
  //     department: 'Lima',
  //     province: 'Lima',
  //     district: 'Lima',
  //     name: 'DI Tolla Pub y MKT EIRL',
  //     address: 'Jr. Lampa 659'
  //   }
  // },
  // {
  //   alias: 'Lima, Lima',
  //   data: {
  //     department: 'Lima',
  //     province: 'Lima',
  //     district: 'Lima',
  //     name: 'Impulso Empresa de Servicios SAC',
  //     address: 'Av. Arenales 680'
  //   }
  // },
  {
    alias: 'Lima, Lima',
    data: {
      department: 'Lima',
      province: 'Lima',
      district: 'Lima',
      name: 'Macpherson S.R.L.',
      address: 'Av. Oscar R. Benavides 1623 - 425-5015 / 337-0083 / 998 037 246 / 998 037 245'
    }
  },
  {
    alias: 'Lima, Lince',
    data: {
      department: 'Lima',
      province: 'Lima',
      district: 'Lince',
      name: 'Comercial Gstar E.I.R.L.',
      address: 'Av. Arenales 1827 - 415-3213 / 953 790024'
    }
  },
  {
    alias: 'Lima, Lince',
    data: {
      department: 'Lima',
      province: 'Lima',
      district: 'Lince',
      name: 'Publicidad y Servicios Multiples EIRL',
      address: 'Jr. Mateo Pumacahua N° 2541 - 913-902-940 / 965-394-560'
    }
  },
  {
    alias: 'Lima, Lince',
    data: {
      department: 'Lima',
      province: 'Lima',
      district: 'Lince',
      name: 'R&R Publiservice SAC.',
      address: 'Calle Risso Nro 278 Int. 102 - 993783046'
    }
  },
  // {
  //   alias: 'Lima, Los Olivos',
  //   data: {
  //     department: 'Lima',
  //     province: 'Lima',
  //     district: 'Los Olivos',
  //     name: 'Inversiones Generales Calle & Loli SAC',
  //     address: 'Av. Palmeras 5144'
  //   }
  // },
  {
    alias: 'Lima, Miraflores',
    data: {
      department: 'Lima',
      province: 'Lima',
      district: 'Miraflores',
      name: 'LGA Publicidad SAC',
      address: 'Ca. Luis Arias Schereiber 148 Of. 202 Aurora - 2664042'
    }
  },
  // {
  //   alias: 'Lima, Miraflores',
  //   data: {
  //     department: 'Lima',
  //     province: 'Lima',
  //     district: 'Miraflores',
  //     name: 'Mar Representaciones SAC',
  //     address: 'Av. Pardo 620 Int. ST14'
  //   }
  // },
  {
    alias: 'Lima, Miraflores',
    data: {
      department: 'Lima',
      province: 'Lima',
      district: 'Miraflores',
      name: 'Peru Nexxos',
      address: 'Cal. Alcanfores Nro 267 Int. 206 - 997897058'
    }
  },
  // {
  //   alias: 'Lima, Miraflores',
  //   data: {
  //     department: 'Lima',
  //     province: 'Lima',
  //     district: 'Miraflores',
  //     name: 'Santa Barbara Comunicaciones',
  //     address: 'Av. La Mar 416 - Santa Cruz'
  //   }
  // },
  // {
  //   alias: 'Lima, Pueblo Libre',
  //   data: {
  //     department: 'Lima',
  //     province: 'Lima',
  //     district: 'Pueblo Libre',
  //     name: 'Mora Publicidad y Representaciones SAC (Sucursal)',
  //     address: 'Av. Sucre 493'
  //   }
  // },
  {
    alias: 'Lima, Puente Piedra',
    data: {
      department: 'Lima',
      province: 'Lima',
      district: 'Puente Piedra',
      name: 'Markakev E.I.R.L.',
      address: 'Av. Buenos Aires 246 - 548-8010 / 960548178'
    }
  },
  // {
  //   alias: 'Lima, S.M.Porres',
  //   data: {
  //     department: 'Lima',
  //     province: 'Lima',
  //     district: 'S.M.Porres',
  //     name: 'CR Publicidad & Servicios SAC',
  //     address: 'Av. Peru 2473'
  //   }
  // },
  {
    alias: 'Lima, S.M.Porres',
    data: {
      department: 'Lima',
      province: 'Lima',
      district: 'S.M.Porres',
      name: 'Model Comunicaciones SAC',
      address: 'Av. Gerardo Unger 4321 - 955 573 812'
    }
  },
  {
    alias: 'Lima, S.M.Porres',
    data: {
      department: 'Lima',
      province: 'Lima',
      district: 'S.M.Porres',
      name: 'Otorongo AP SAC.',
      address: 'Av. Tomas Valle con Av. Universitaria - 531-7624 / 968663174'
    }
  },
  // {
  //   alias: 'Lima, San Borja',
  //   data: {
  //     department: 'Lima',
  //     province: 'Lima',
  //     district: 'San Borja',
  //     name: 'Cocchella Costa S.C.R.L.',
  //     address: 'Av. Aviacion 2491'
  //   }
  // },
  // {
  //   alias: 'Lima, San Borja',
  //   data: {
  //     department: 'Lima',
  //     province: 'Lima',
  //     district: 'San Borja',
  //     name: 'Portofino Publicidad y Servicios EIRL',
  //     address: 'Av. Canada 3560 Urb. Villa Jardin'
  //   }
  // },
  // {
  //   alias: 'Lima, San Borja',
  //   data: {
  //     department: 'Lima',
  //     province: 'Lima',
  //     district: 'San Borja',
  //     name: 'San Miguel Service SAC',
  //     address: 'Av. San Luis 2006 Of. 202-A'
  //   }
  // },
  // {
  //   alias: 'Lima, San Isidro',
  //   data: {
  //     department: 'Lima',
  //     province: 'Lima',
  //     district: 'San Isidro',
  //     name: 'Laos & Asociados S.R.L.',
  //     address: 'Manuela A. Fuentes 420 Int. 101'
  //   }
  // },
  // {
  //   alias: 'Lima, San Miguel',
  //   data: {
  //     department: 'Lima',
  //     province: 'Lima',
  //     district: 'San Miguel',
  //     name: 'Inversiones & Servicios Chirirka EIRL',
  //     address: 'Av. La Mar Nro 2275 Int. 201 (C.C Shopping Center)'
  //   }
  // },
  // {
  //   alias: 'Lima, San Miguel',
  //   data: {
  //     department: 'Lima',
  //     province: 'Lima',
  //     district: 'San Miguel',
  //     name: 'Publicidad y Representaciones EIRL',
  //     address: 'Av. Elmer J. Faucett 367 Urb. Maranga'
  //   }
  // },
  // {
  //   alias: 'Lima, Santa Anita',
  //   data: {
  //     department: 'Lima',
  //     province: 'Lima',
  //     district: 'Santa Anita',
  //     name: 'Piscis EIRL',
  //     address: 'Los Ruiseñores 204-A'
  //   }
  // },
  {
    alias: 'Lima, Santa Anita',
    data: {
      department: 'Lima',
      province: 'Lima',
      district: 'Santa Anita',
      name: 'Piscis EIRL',
      address: 'Cal. Los Flamengos Nro. 110A Int. 2 - 937012533 / 998283622'
    }
  },
  // {
  //   alias: 'Lima, Surco',
  //   data: {
  //     department: 'Lima',
  //     province: 'Lima',
  //     district: 'Surco',
  //     name: 'Distribuidora Sur Peru SAC',
  //     address: 'Av. Los Proceres 377'
  //   }
  // },
  // {
  //   alias: 'Lima, Surco',
  //   data: {
  //     department: 'Lima',
  //     province: 'Lima',
  //     district: 'Surco',
  //     name: 'DLC Pride Publicity SAC',
  //     address: 'Jr. Cartavio 105 - Monterrico'
  //   }
  // },
  {
    alias: 'Lima, Surco',
    data: {
      department: 'Lima',
      province: 'Lima',
      district: 'Surco',
      name: 'Mora Publicidad y Representaciones SAC',
      address: 'Av. Primavera 120 Int.A Of. 213 Urb. Chacarilla del Estanque - 2195343 / WSP. 987947143'
    }
  },
  {
    alias: 'Lima, Surco',
    data: {
      department: 'Lima',
      province: 'Lima',
      district: 'Surco',
      name: 'El Comercio',
      address: 'Pj. Yanacocha Nro. 171 Dpto. 401 URB. Tambo de Monterrico - 715-1110 / 715-0589'
    }
  },
  // {
  //   alias: 'Lima, Surco',
  //   data: {
  //     department: 'Lima',
  //     province: 'Lima',
  //     district: 'Surco',
  //     name: 'Pedro Fernando Yataco Tasaico',
  //     address: 'Jr. Esteban Camere Nro 136 Urb. San Roque'
  //   }
  // },
  // {
  //   alias: 'Lima, Surco',
  //   data: {
  //     department: 'Lima',
  //     province: 'Lima',
  //     district: 'Surco',
  //     name: 'Publimarines SAC',
  //     address: 'Calle Preciados 149 - 201'
  //   }
  // },
  // {
  //   alias: 'Lima, Surquillo',
  //   data: {
  //     department: 'Lima',
  //     province: 'Lima',
  //     district: 'Surquillo',
  //     name: 'HS Publicidad SAC',
  //     address: 'Av. Angamos Este 913'
  //   }
  // },
  // {
  //   alias: 'Huamanga, Huamanga',
  //   data: {
  //     department: 'Ayacucho',
  //     province: 'Huamanga',
  //     district: 'Huamanga',
  //     name: 'Centro Superior Tecnologico y Sistemas Peru EIRL',
  //     address: 'Jr. Cusco N° 303, Urb. Cercado, Ayacucho'
  //   }
  // },
  // {
  //   alias: 'Huancayo, Huancayo',
  //   data: {
  //     department: 'Junin',
  //     province: 'Huancayo',
  //     district: 'Huancayo',
  //     name: 'Copias Alfa EIRL',
  //     address: 'Julio C. Tello N° 274, El Tambo (Esq. con Jr. Sta Isabel)'
  //   }
  // },
  // {
  //   alias: 'Ica, Ica',
  //   data: {
  //     department: 'Ica',
  //     province: 'Ica',
  //     district: 'Ica',
  //     name: 'Edward Enrique Quispe Contreras',
  //     address: 'Calle Tacna N° 130, Int. 28, Galería Bunker Plaza'
  //   }
  // },
  // {
  //   alias: 'Trujillo, Trujillo',
  //   data: {
  //     department: 'La Libertad',
  //     province: 'Trujillo',
  //     district: 'Trujillo',
  //     name: 'Full Marketing Clase SAC',
  //     address: 'Av. España N° 2155 Int. 208 Cent Cercado Trujillo'
  //   }
  // },
  // {
  //   alias: 'Arequipa, Arequipa',
  //   data: {
  //     department: 'Arequipa',
  //     province: 'Arequipa',
  //     district: 'Arequipa',
  //     name: 'Joblan Servicios EIRL',
  //     address: 'Calle Nueva N° 319, Cercado, Arequipa'
  //   }
  // },
  // {
  //   alias: 'Chiclayo, Chiclayo',
  //   data: {
  //     department: 'Lambayeque',
  //     province: 'Chiclayo',
  //     district: 'Chiclayo',
  //     name: 'Palomino Galarza Magda Nelly',
  //     address: 'Av. Oriente N° 183 Urb. San Juan Lambayeque'
  //   }
  // },
  // {
  //   alias: 'Chiclayo, Chiclayo',
  //   data: {
  //     department: 'Lambayeque',
  //     province: 'Chiclayo',
  //     district: 'Chiclayo',
  //     name: 'Distribucion de Publicaciones Ayala SRL',
  //     address: 'Pj. Woyke N° 179 Int. 204 Centro de Chiclayo'
  //   }
  // },
  // {
  //   alias: 'Trujillo, Trujillo',
  //   data: {
  //     department: 'La Libertad',
  //     province: 'Trujillo',
  //     district: 'Trujillo',
  //     name: 'Externa Consulting SAC',
  //     address: 'Jr. Alfonso Ugarte N° 471, Cercado, Trujillo'
  //   }
  // },
  // {
  //   alias: 'Chiclayo, Chiclayo',
  //   data: {
  //     department: 'Lambayeque',
  //     province: 'Chiclayo',
  //     district: 'Chiclayo',
  //     name: 'Inversiones Zeus SAC',
  //     address: 'Pj. Woyke N° 179 Int. 204 Centro de Chiclayo'
  //   }
  // },
  // {
  //   alias: 'Piura, Piura',
  //   data: {
  //     department: 'Piura',
  //     province: 'Piura',
  //     district: 'Piura',
  //     name: 'Komunica2 Publicidad y Marketing EIRL',
  //     address: 'Jr. Callao 330, Of. R (2° piso) C.C. La Cholita'
  //   }
  // },
  // {
  //   alias: 'Arequipa, Arequipa',
  //   data: {
  //     department: 'Arequipa',
  //     province: 'Arequipa',
  //     district: 'Arequipa',
  //     name: 'Publicidad & Comercio EIRL',
  //     address: 'Calle Los Arces N° 218 Of. 201, Cayma, Arequipa'
  //   }
  // },
];
